import { useState } from "react";

import styled from "styled-components";

import { personTypesData } from "../data/personTypesData";
import arrowDown from "../svg/down-arrow-white.svg";

const Container = styled.div`
  position: absolute;
  top: 42%;
  left: 50%;
  z-index: 100;
  cursor: pointer;

  .mbti-label-container {
    display: inline-block;

    p {
      margin: 0;
      margin-bottom: -5px;
    }

    h2 {
      font-size: 2em;
      text-decoration-thickness: 1px;
      text-decoration-line: underline;
      text-decoration-style: dotted;
      margin: 10px 0;
      display: inline-block;
      letter-spacing: 0.2em;
    }

    img {
      width: 16px;
      height: auto;
      position: absolute;
      top: 30px;
      right: 55%;
      transform: translateX(90px)
        ${({ isSelectorShown }) =>
          isSelectorShown ? `rotate(180deg)` : `rotate(0deg)`};
      transition: transform 0.25s ease;
    }
  }

  p {
    font-size: 0.85em;
    opacity: 0.8;
    width: 280px;
  }

  @media (min-width: 376px) {
    top: 50%;
  }

  ${({ radius }) => `
    transform: translate(-50%, -${radius * 1.5}px);
  `}
`;

const SelectorContainer = styled.div`
  border: 1px solid #fff;
  border-radius: 15px;
  background-color: #424242ee;
  padding: 10px;
  box-sizing: border-box;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%);
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, calc((100% - 24px) / 4));
  row-gap: 8px;
  column-gap: 8px;
  padding: 0px;
  box-sizing: border-box;

  button {
    height: 40px;
    border-radius: 15px;
    cursor: pointer;
    background-color: transparent;
    border: 1px solid #fff;
    color: #fff;
    font-size: 14px;

    &:hover {
      background-color: #fff;
      color: #424242;
      font-weight: 700;
    }
  }
`;

const TypeSelector = ({ mbtiObj, paramStates, radius }) => {
  const [{ ieLetter, nsLetter, tfLetter, pjLetter }] = mbtiObj;
  const [{ setNs }, { setTf }, { setXvn }] = paramStates;
  const [isSelectorShown, setIsSelectorShown] = useState(false);

  function lowerFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
  }

  const personTypes = personTypesData.map((p) => p.type);
  const getParamsOfType = (type) =>
    personTypesData[personTypes.indexOf(type)].params;
  const getProfileDescOfType = (type) => {
    const profile =
      personTypesData[personTypes.indexOf(type)].profile.description;
    return lowerFirstLetter(profile);
  };
  const currMbtiType = ieLetter + nsLetter + tfLetter + pjLetter;

  const handleSelector = () => {
    setIsSelectorShown(!isSelectorShown);
  };

  const handleButtonClick = (type) => {
    const { xvn: xvnVal, ns: nsVal, tf: tfVal } = getParamsOfType(type);
    setXvn(xvnVal);
    setNs(nsVal);
    setTf(tfVal);
    setIsSelectorShown(false);
  };

  return (
    <Container className="mbti-container" {...{ radius, isSelectorShown }}>
      <div className="mbti-label-container" onClick={handleSelector}>
        <p>If you are an: </p>
        <h2 className="mbti-label">{currMbtiType}</h2>
        <img src={arrowDown} />
        <p>you are more likely {getProfileDescOfType(currMbtiType)}</p>
      </div>
      {isSelectorShown && (
        <SelectorContainer>
          <p>Select type:</p>
          <GridContainer>
            {personTypes.map((type) => (
              <button onClick={() => handleButtonClick(type)}>{type}</button>
            ))}
          </GridContainer>
        </SelectorContainer>
      )}
    </Container>
  );
};

export default TypeSelector;
